import React from 'react'
import { global } from '../../../../global'
import phonePerson from '../../../../assets/pictures/phoneHome.png'
import './styles.css'

const FindOut = () => {

    const {
        AppStoreLogo,
        GooglePlayLogo
    } = global.img.logos

    return (
        <div className='contain-find-out'>
            <img src={phonePerson} alt="home-phone" className='home-phone-person'/>
            <section className='contain-info-findout'>
                <h2>
                    Enterate de Todo
                </h2>
                <p className='p-find-out'>
                    No te pierdas de nada con
                    <span className='letters-700-find-out'>Nuestra App</span>
                </p>
                <p className='letters-700-find-out'>
                    Descargala gratis en
                </p>
                <div className='contain-img-logos'>
                    <img src={AppStoreLogo} alt="appStore" className='app-Store-img' />
                    <img src={GooglePlayLogo} alt="playStore" className='play-Store-img'/>
                </div>
            </section>
        </div>
    )
}

export default FindOut